/**
 * 封装axios 用于非网关接口请求
 */
import axios from 'axios';
import { Message } from 'element-ui';
import store from '@/store';
import config from '@/config';

const addErrorLog = error => {
	const {
		statusText,
		status,
		request: { responseURL }
	} = error;

	let info = {
		type: 'api',
		status,
		message: statusText,
		url: responseURL
	};
	store.dispatch('addErrorLog', info);
};

// 设置超时
const TIMEOUT = 15;

// 创建axios实例
const instance = axios.create({
	timeout: TIMEOUT * 1000 // request timeout (s)
});

instance.defaults.withCredentials = true;

// 添加请求拦截
instance.interceptors.request.use(
	config => {
		console.log('base请求拦截: ', config);
		return config;
	},
	err => {
		return Promise.reject(err);
	}
);

// 添加响应拦截
instance.interceptors.response.use(
	res => {
		if (res && res.data) {
			return Promise.resolve(res.data);
		} else {
			Message({
				message: '请求错误',
				type: 'error',
				duration: 5 * 1000
			});
			return Promise.reject(res);
		}
	},
	err => {
		Message({
			message: '请求失败,请刷新重试',
			type: 'error',
			duration: 5 * 1000
		});

		if (config.log) {
			// 获取错误信息
			let error = err.response;
			if (!error) {
				const {
					request: { statusText, status },
					config
				} = JSON.parse(JSON.stringify(err));

				error = {
					statusText,
					status,
					request: { responseURL: config.url }
				};
			}
			// 上报api异常信息
			addErrorLog(error);
		}
		return Promise.reject(err);
	}
);

export default instance;
